const mediasApi = ({ apiClient }) => ({
  list(params) {
    return apiClient.get('medias', {}, params)
  },
  show(id) {
    return apiClient.get(`medias/${id}`, {}, {})
  },
  store(payload) {
    return apiClient.axios().post('medias', payload)
  },
  update(id, payload) {
    return apiClient.axios().put(`medias/${id}`, payload)
  },
  delete(id) {
    return apiClient.delete(`medias/${id}`)
  },
})

export default mediasApi
